
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { MdMailOutline } from "react-icons/md";
import img from "../images/ciar_Logo.png";
import "./navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);

  const categories = [
    "Flow Measurement",
    "Level Measurement",
    "Pressure Measurement ",
    "Temperature Measurement",
    "Liquid Analyzers",
    "Gas Analyser",
    "vibration monitoring",
  ];
  const categories1 = [
    "Ball Valve",
    "Butterfly Valve"
    
  ];

  return (
    <nav className="custom-navbar">
      {/* 🔹 Top Section */}
      <div className="navbar-top">
        <a href="#" className="logo">
          <img src={img} alt="Logo" />
        </a>

        <div className="contact-info">
          <span>
            <FiPhoneCall /> +91 98400 98717
          </span>
          <span>
            <MdMailOutline /> Sriarun@ciratechnology.com
          </span>
        </div>

        {/* ☰ Toggle Button */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </div>

      {/* 🔹 Navigation Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        {/* Mobile Header */}
        <div className="menu-header">
          <h4>Menu</h4>
          <button className="close-btn" onClick={() => setMenuOpen(false)}>
            ✖
          </button>
        </div>

        <li>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
           HOME
          </NavLink>
        </li>
        {/* PRODUCTS Dropdown */}
        <li
          className={`dropdown1 ${dropdownOpen1 ? "active" : ""}`}
          onMouseEnter={() => window.innerWidth > 768 && setDropdownOpen1(true)}
          onMouseLeave={() => window.innerWidth > 768 && setDropdownOpen1(false)}
        >
          <button
            className="dropdown-toggle1"
            onClick={() => setDropdownOpen1(!dropdownOpen1)}
          >
            PRODUCTS ▾
          </button>

          {dropdownOpen1 && (
            <div className="dropdown-menu1">
              <div className="dropdown-section">
                <span className="dropdown-category-title">INSTRUMENTATION</span>
                <ul>
                  {categories.map((cat, index) => (
                    <li key={index}>
                      <NavLink
                        to={`/products/${cat.trim().toLowerCase()}`}
                        onClick={() => {
                          setDropdownOpen1(false);
                          setMenuOpen(false);
                        }}
                      >
                        {cat.trim()}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="dropdown-section">
                <span className="dropdown-category-title">CONTROL VALVES</span>
                <ul>
                  {categories1.map((cat, index) => (
                    <li key={index}>
                      <NavLink
                        to={`/products/${cat.trim().toLowerCase()}`}
                        onClick={() => {
                          setDropdownOpen1(false);
                          setMenuOpen(false);
                        }}
                      >
                        {cat.trim()}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </li>

        <li>
          <NavLink to="/Aboutus" onClick={() => setMenuOpen(false)}>
             ABOUT US
          </NavLink>
        </li>

        <li>
          <NavLink to="/Contact" onClick={() => setMenuOpen(false)}>
            CONTACT
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
